import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export const parseForwardProps =
  <CustomProps>(props: Array<keyof CustomProps>) =>
  (propName: PropertyKey): boolean =>
    !props.map(p => p.toString()).includes(propName.toString())

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}